/* eslint-disable react/no-unescaped-entities */
/* EcommerceTab — Bol API Diagnose + Recover Modal */
import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { AlertCircle, X, Loader2, RefreshCw, Download } from 'lucide-react';
import { API, hdrs } from '../../../lib/api';


export default function DiagnoseDialog({
    diagResult,
    onClose,
    scanResult,
    setScanResult,
    scanning,
    onScanLostLabels,
    recovering,
    onRecoverLostLabels,
}) {
    const [labelIdToTest, setLabelIdToTest] = useState('');
    const [testingLabel, setTestingLabel] = useState(false);
    const [labelTestResult, setLabelTestResult] = useState(null);

    if (!diagResult) return null;

    const testLabelById = async () => {
        if (!labelIdToTest) return;
        setTestingLabel(true);
        try {
            const r = await axios.post(`${API}/api/bol/diagnose/test-label`,
                { shipping_label_id: labelIdToTest },
                { headers: hdrs() });
            setLabelTestResult(r.data);
        } catch (e) {
            toast.error(e.response?.data?.detail || 'Test hatası');
        } finally {
            setTestingLabel(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" data-testid="bol-diag-modal">
            <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] flex flex-col">
                <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <AlertCircle size={18} className="text-purple-700" />
                        <h3 className="text-base font-bold text-gray-900">Bol API Teşhis Raporu (v2 — gerçek endpoint'ler)</h3>
                    </div>
                    <button onClick={onClose} className="h-8 w-8 flex items-center justify-center rounded-md hover:bg-gray-100">
                        <X size={16} />
                    </button>
                </div>
                <div className="p-5 overflow-y-auto flex-1 space-y-4">
                    <div className={`rounded-lg p-3 border ${
                        diagResult.verdict === 'API_TAM_CALISIYOR' ? 'bg-emerald-50 border-emerald-300 text-emerald-900'
                            : diagResult.verdict === 'GENEL_SORUN' ? 'bg-rose-50 border-rose-300 text-rose-900'
                                : 'bg-amber-50 border-amber-300 text-amber-900'
                    }`}>
                        <div className="font-bold text-sm mb-1">Sonuç: {diagResult.verdict}</div>
                        <div className="text-xs leading-relaxed">{diagResult.verdict_text}</div>
                    </div>

                    <div className="flex items-center gap-3 text-xs">
                        <span className="font-semibold">{diagResult.tested} test edildi</span>
                        <span className="text-emerald-700">✓ {diagResult.passing} başarılı</span>
                        <span className="text-rose-700">✗ {diagResult.failing} başarısız</span>
                    </div>

                    <div className="border border-gray-200 rounded-lg overflow-hidden">
                        <table className="w-full text-xs">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="p-2 text-left font-semibold">Test</th>
                                    <th className="p-2 text-right font-semibold w-24">Sonuç</th>
                                </tr>
                            </thead>
                            <tbody>
                                {diagResult.results.map((r, i) => (
                                    <tr key={i} className="border-t border-gray-100">
                                        <td className="p-2">
                                            <div className="font-medium text-gray-900">{r.test}</div>
                                            <div className="text-[10px] text-gray-500 font-mono mt-0.5">{r.endpoint}</div>
                                            {r.detail && <div className="text-[10px] text-gray-600 mt-1 italic">{r.detail}</div>}
                                        </td>
                                        <td className="p-2 text-right">
                                            <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-semibold ${
                                                r.ok === true ? 'bg-emerald-100 text-emerald-800'
                                                    : r.ok === false ? 'bg-rose-100 text-rose-800'
                                                        : 'bg-gray-100 text-gray-600'
                                            }`}>
                                                {r.status}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Gerçek shippingLabelId ile test */}
                    <div className="bg-purple-50 border border-purple-300 rounded-lg p-3">
                        <div className="text-xs font-bold text-purple-900 mb-2">🎯 PDF Çekme Testi (kesin sonuç)</div>
                        <div className="text-[11px] text-purple-800 mb-3 leading-relaxed">
                            Bol Partner Portal → Verzending → Verzendlabels → bir etikete tıkla → URL'de ya da detayda <b>shippingLabelId</b>'yi (uzun bir UUID) kopyala, aşağıya yapıştır.
                            Eğer PDF gelirse, tam otomatik akış kurabiliriz.
                        </div>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                placeholder="shippingLabelId (UUID)"
                                value={labelIdToTest}
                                onChange={e => setLabelIdToTest(e.target.value)}
                                className="flex-1 h-9 px-3 text-xs font-mono border border-purple-300 rounded-md"
                            />
                            <button
                                onClick={testLabelById}
                                disabled={testingLabel || !labelIdToTest}
                                className="h-9 px-3 text-xs font-semibold text-white bg-purple-700 hover:bg-purple-800 disabled:opacity-50 rounded-md">
                                {testingLabel ? <Loader2 size={12} className="animate-spin" /> : 'PDF Test Et'}
                            </button>
                        </div>
                        {labelTestResult && (
                            <div className="mt-3 p-2 bg-white rounded border border-purple-200 text-[11px] space-y-1">
                                <div className={`font-bold ${labelTestResult.ok ? 'text-emerald-700' : 'text-rose-700'}`}>
                                    {labelTestResult.conclusion}
                                </div>
                                <div className="font-mono text-[10px] text-gray-600">
                                    HEAD: HTTP {labelTestResult.head?.status} {labelTestResult.head?.track_trace && `· T&T: ${labelTestResult.head.track_trace}`}
                                </div>
                                <div className="font-mono text-[10px] text-gray-600">
                                    GET: HTTP {labelTestResult.get?.status} {labelTestResult.get?.pdf_size_bytes ? `· ${labelTestResult.get.pdf_size_bytes} bytes PDF` : ''}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* 💰 KAYIP ETİKET KURTARMA */}
                    <div className="bg-emerald-50 border-2 border-emerald-400 rounded-lg p-4">
                        <div className="text-sm font-bold text-emerald-900 mb-2">💰 Kayıp Etiket Kurtarma</div>
                        <div className="text-[11px] text-emerald-800 mb-3 leading-relaxed">
                            Geçmişte POST'lanmış ama PDF'i indirilememiş etiketleri Bol'dan otomatik bulup indirir.
                            Para harcamadan, geçmiş ödemelerin karşılığını alır.
                        </div>
                        {!scanResult ? (
                            <button
                                onClick={onScanLostLabels}
                                disabled={scanning}
                                className="h-9 px-4 text-xs font-semibold text-white bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 rounded-md inline-flex items-center gap-2"
                                data-testid="bol-scan-lost-btn">
                                {scanning ? <Loader2 size={14} className="animate-spin" /> : <RefreshCw size={14} />}
                                {scanning ? 'Bol\'da kayıp etiket aranıyor...' : 'Kayıp Etiketleri Tara'}
                            </button>
                        ) : (
                            <div className="space-y-2">
                                <div className="text-xs font-semibold text-emerald-900">
                                    {scanResult.count} kayıp etiket bulundu
                                </div>
                                {scanResult.count > 0 && (
                                    <>
                                        <div className="bg-white rounded border border-emerald-200 max-h-40 overflow-y-auto">
                                            {scanResult.items.map((it, i) => (
                                                <div key={i} className="p-2 border-b border-gray-100 last:border-0 text-[11px]">
                                                    <div className="font-mono font-semibold">{it.order_id}</div>
                                                    <div className="text-gray-600">{it.customer}</div>
                                                    <div className="text-[10px] text-gray-500 font-mono">{it.shipping_label_id}</div>
                                                </div>
                                            ))}
                                        </div>
                                        <button
                                            onClick={() => onRecoverLostLabels(scanResult.items.map(i => i.order_id))}
                                            disabled={recovering}
                                            className="h-9 px-4 text-xs font-semibold text-white bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50 rounded-md inline-flex items-center gap-2"
                                            data-testid="bol-recover-btn">
                                            {recovering ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />}
                                            {recovering ? 'Kurtarılıyor...' : `${scanResult.count} Etiketin PDF'ini İndir`}
                                        </button>
                                    </>
                                )}
                                <button
                                    onClick={() => setScanResult(null)}
                                    className="ml-2 h-9 px-3 text-xs font-medium text-emerald-700 bg-white border border-emerald-300 rounded-md">
                                    Tekrar Tara
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
